import HyperlinkMessage from './HyperlinkMessage';

export default HyperlinkMessage;
